"use client";

import type { ReactNode } from "react";

import defaultStyles from "@stadium/ui/src/components/header/main.module.scss";
import { STICKY_HEADER_REF } from "@stadium/ui/src/components/header";

type ModularStyles = typeof defaultStyles;

export type SwagmagicStickyHeaderProps = {
  children: ReactNode;
  styles?: ModularStyles;
  rootClass?: string;
  className?: string;
};

export function SwagmagicStickyHeader({
  styles = defaultStyles,
  children,
  rootClass = "",
  className = "",
}: Readonly<SwagmagicStickyHeaderProps>) {
  const rootClasses = [styles.stickyTopHeader, styles.portalContainer, rootClass]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    <div id="sticky-header-root" ref={STICKY_HEADER_REF} className={rootClasses || undefined}>
      <div data-id="sticky-header" className={className}>
        {children}
      </div>
    </div>
  );
}
